import { eventsApi } from '../object-plus/index.js';
import { transactionApi } from "../transactions.js";
const { begin: _begin, markAsDirty: _markAsDirty, commit } = transactionApi;
const { trigger3 } = eventsApi;
export function setAttribute(record, name, value) {
    const isRoot = begin(record), options = {};
    if (record._attributes[name].doUpdate(value, record, options)) {
        markAsDirty(record, options);
        trigger3(record, 'change:' + name, record, record.attributes[name], options);
    }
    isRoot && commit(record);
}
function begin(record) {
    if (_begin(record)) {
        record._previousAttributes = new record.AttributesCopy(record.attributes);
        record._changedAttributes = null;
        return true;
    }
    return false;
}
function markAsDirty(record, options) {
    if (record._changedAttributes) {
        record._changedAttributes = null;
    }
    return _markAsDirty(record, options);
}
export const UpdateRecordMixin = {
    transaction(fun, options = {}) {
        const isRoot = begin(this);
        fun.call(this, this);
        isRoot && commit(this);
    },
    _onChildrenChange(child, options) {
        const { _ownerKey } = child, attribute = this._attributes[_ownerKey];
        if (!attribute || attribute.propagateChanges)
            this.forceAttributeChange(_ownerKey, options);
    },
    forceAttributeChange(key, options = {}) {
        const isRoot = begin(this);
        if (markAsDirty(this, options)) {
            trigger3(this, 'change:' + key, this, this.attributes[key], options);
        }
        isRoot && commit(this);
    },
    _createTransaction(a_values, options = {}) {
        const isRoot = begin(this), changes = [], nested = [], { _attributes } = this, values = options.parse ? this.parse(a_values, options) : a_values;
        let unknown;
        if (shouldBeAnObject(this, values, options)) {
            for (let name in values) {
                const spec = _attributes[name];
                if (spec) {
                    if (spec.doUpdate(values[name], this, options, nested)) {
                        changes.push(name);
                    }
                }
                else {
                    unknown || (unknown = []);
                    unknown.push(`'${name}'`);
                }
            }
            if (unknown) {
                unknownAttrsWarning(this, unknown, { values }, options);
            }
        }
        if (changes.length && markAsDirty(this, options)) {
            return new RecordTransaction(this, isRoot, nested, changes);
        }
        for (let pendingTransaction of nested) {
            pendingTransaction.commit(this);
        }
        isRoot && commit(this);
    }
};
export function unknownAttrsWarning(record, unknown, props, options) {
    record._log('warn', 'Type-R:UnknownAttrs', `undefined attributes ${unknown.join(', ')} are ignored.`, props, options.logger);
}
export function constructorsMixin(attrDefs) {
    const attrs = Object.keys(attrDefs);
    const AttributesCopy = new Function('values', `
        ${attrs.map(attr => `
            this.${attr} = values.${attr};
        `).join('')}
    `);
    AttributesCopy.prototype = Object.prototype;
    const Attributes = new Function('record', 'values', 'options', `
        var _attrs = record._attributes;

        ${attrs.map(attr => `
            this.${attr} = _attrs.${attr}.doInit( values.${attr}, record, options );
        `).join('')}
    `);
    Attributes.prototype = Object.prototype;
    return { Attributes, AttributesCopy };
}
export function shouldBeAnObject(record, values, options) {
    if (values && values.constructor === Object)
        return true;
    record._log('error', 'Type-R:InvalidObject', 'update with non-object is ignored!', { values }, options.logger);
    return false;
}
export class RecordTransaction {
    constructor(object, isRoot, nested, changes) {
        this.object = object;
        this.isRoot = isRoot;
        this.nested = nested;
        this.changes = changes;
    }
    commit(initiator) {
        const { nested, object, changes } = this;
        for (let transaction of nested) {
            transaction.commit(object);
        }
        const { attributes, _isDirty } = object;
        for (let key of changes) {
            trigger3(object, 'change:' + key, object, attributes[key], _isDirty);
        }
        this.isRoot && commit(object, initiator);
    }
}
//# sourceMappingURL=updates.js.map